export const isEven = (num: number): boolean => !(num % 2);
